<template>
        <div>
            <form class="form-inline" @submit.prevent="saveDiagnosisTemplate">
                <label class="mr-sm-2" for="disease">Diagnózy a výkony dle šablony</label>
                <div class="col-md-4">
                    <multiselect v-model="selected" id="search" label="name" track-by="id" placeholder="vybrat šablonu" :options="diagnosisTemplates" :multiple="false" :internal-search="false" :close-on-select="true" :max-height="600" :show-no-results="false" :hide-selected="false" @select="selectDiagnosisTemplate" selectLabel=""></multiselect>
                </div>
                <button type="submit" class="btn btn-sm btn-success" id="addDiagnosisTemplateButton">Přidat podle šablony</button>
                <!-- <button class="btn btn-primary btn-sm disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>-->
            </form>
        </div>
</template>

<script>
  // import auth from '../../auth'
  // import error from '../../error'
  import apiMixin from '@/mixins'

  // import Modal from './ConfirmVisitModal.vue'

  export default {
    data () {
      return {
        selected: '',
        fromSearch: '',
        // Diagnosis Tenmplate (post)
        diagnosisTemplate: null,
        diagnosisTemplatePending: false,
        diagnosisTemplateError: false,
        diagnosisTemplateDone: false,
        // Diagnosis Templates
        diagnosisTemplates: [],
        diagnosisTemplatesPending: false,
        diagnosisTemplatesError: false
      }
    },
    /* computed: mapState({
      // diseases: state => state.diseases,
      // diseasesError: state => state.error.diseases,
      // diseasesPending: state => state.pending.diseases,
      // diagnosis: state => state.diagnosis,
      // diagnosisError: state => state.error.diagnosis
      // diagnosisPending: state => state.pending.diagnosis
    }), */
    mixins: [apiMixin],
    methods: {
      // ...mapActions(['searchDisease']),
      saveDiagnosisTemplate () {
        this.postDiagnosisTemplate(this.$route.params.visitid, this.diagnosisTemplate)
        // this.postDiagnosis({params: {visitId: this.$route.params.visitid}, data: this.diagnosis})
        /* this.diagnosisPending = true
        this.$http.post('/visit/' + this.$route.params.visitid + '/diagnosis', this.diagnosis, {emulateJSON: true}).then(response => {
          this.diagnosisPending = false
          this.diagnosisAdded()
        }, response => {
          this.errors = response.body.errors
          this.diagnosisPending = false
        }) */
      },
      /* getDiseases (search) {
        this.diseasesPending = true
        this.get_params.search = search
        this.$http.get('/icd/disease', {params: this.get_params}).then(response => {
          this.diseases = response.data
          this.diseasesPending = false
        }, response => {
          this.diseasesPending = false
        })
        // this.searchDisease({params: {search: search}})
      }, */
      selectDiagnosisTemplate (val) {
        this.diagnosisTemplate = val.id
        document.getElementById('addDiagnosisTemplateButton').focus()
      }
    },
    beforeMount () {
      this.getDiagnosisTemplates()
      // this.initialSet()
      // this.getVisitPurposes()
    },
    watch: {
      diagnosisTemplateDone (val) {
        if (val === true) {
          this.$emit('update')
          this.diagnosisTemplateDone = false
          this.selected = ''
        }
      }
    },
    components: {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    table.table_calendar > thead > tr > th {
        margin: 0;
        padding: 0;
        font-size: x-small;
        border: none;
        border-left: 1px solid #888;
    }

    table.table_calendar > thead > tr > th:last-of-type {
        border-right: 1px solid #888;
    }

    table.table_calendar > thead > tr > th:first-of-type {
        border: none;
    }

    table.table_calendar > thead > tr > th.halfHour {
        border-left: 1px solid #888;
    }

    table.table_calendar > thead > tr > th.sixth_cell {
        border-right: 1px solid #888;
        background-color: dodgerblue;
    }

    table.table_calendar > tbody > tr > td {
        margin: 0;
        padding: 0;
        border: none;
        border-bottom: 1px solid #888;
        border-right: 1px solid #888;
    }

    table.table_day {
        margin: 0;
    }
    table.table_day td {
        padding: 0;
        margin: 0;
        border: none;
        border-right: 1px dotted black;
        padding: 10px 0 10px 0;
    }

    table.table_day td:last-of-type{
        border-right: none;
    }

    .icon-male {
        color: dodgerblue;
        font-weight: bold;
    }

    .icon-female {
        color: deeppink;
        font-weight: bold;
    }

    .table > tbody > tr > td, .table > tfoot > tr > td {
        vertical-align: middle;
    }

    td.selected {
        background-color: deeppink;
    }

    .highlight_hovered tr:hover {
        background-color: #ffa;
    }

    .visit {
        background-color: orange;
        opacity: 0.5;
    }

    .visit-multi {
        background-color: orangered;
        opacity: 0.5;
    }

    .unoccupied{
        background-color: greenyellow;
        opacity: 0.5;
    }

    .hovered_window {
        opacity: 0.9;
    }

    .selected_window {
        background-color: green;
    }

    .hovered_window.visit {
        background-color: orangered;
    }

    .selected_window.visit {
        background-color: red;
    }

    td.hourly {
        border-right: 1px solid black !important;
    }

    td.halfhourly {
        border-right: 1px solid #444 !important;
    }

    td:hover {
        opacity: 0.8;
        cursor:crosshair
    }

    .bold_text {
        font-weight: bold;
    }
    @media screen
    {
        .noPrint{}
        .noScreen{display:none;}
    }

    @media print
    {
        .noPrint{display:none;}
        .noScreen{}
    }

</style>



// WEBPACK FOOTER //
// src/views/Visit/components/AddDiagnosisTemplate.vue?7d6d0d7a